<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.integration.edit.integrations.square.pairTerminal')"
    :info="$t('components.integration.edit.integrations.square.actions.connectDevice.info')"
    :loading="loading"
    :portal="portal"
  >
    <template #heading>
      <img :src="`${api}/v1/integration/icon?guid=${integration.guid}&type=&size=256`" class="h-10 w-10 rounded-xl mx-auto mt-3">
    </template>

    <div class="text-left mt-6">
      <template v-if="!device">
        <o-field-group :label="$t('general.name')" :info="$t('components.integration.edit.integrations.square.terminalLabel')" class="mb-4 block">
          <text-field v-model="name" />
        </o-field-group>

        <o-button
          :disabled="!name"
          :loading="loading"
          variant="primary"
          class="w-full"
          size="lg"
          @click="generateDeviceCode"
        >
          {{ $t('components.integration.edit.integrations.square.actions.connectDevice.generateCode') }}
        </o-button>
      </template>

      <template v-if="device">
        <p class="text-center font-semibold text-gray-800 mb-1">
          {{ $t('components.integration.edit.integrations.square.actions.connectDevice.pairingCode') }}
        </p>
        <p class="text-center text-sm text-gray-600 mb-3">
          {{ $t('components.integration.edit.integrations.square.actions.connectDevice.enterCode') }}
        </p>

        <div class="border rounded p-3 text-center mb-4">
          <p class="text-xl tracking-tight text-center font-semibold">
            {{ device.code }}
          </p>
        </div>

        <o-button variant="primary" class="w-full" size="lg" @click="handleConfirm">
          {{ $t('general.done') }}
        </o-button>
      </template>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { TextField } from '@/components/fields'
import { OFieldGroup } from '@/components/elements'

const { $api, $config } = useNuxtApp()

interface Props {
  integration: Record<string, any>
  portal?: string
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
})

const emit = defineEmits<{
  (e: 'confirm', device: any): void
}>()

const dialog = ref<any>()

const loading = ref(false)
const name = ref('')
const device = ref<any>(null)

const api = computed(() => {
  return $config.public.api
})

function open () {
  dialog.value.open()
}

async function generateDeviceCode () {
  loading.value = true

  try {
    const guid = props.integration.objectID?.() ?? props.integration.guid
    const response = await $api.integration.terminal(guid, {
      action: 'pair',
      params: {
        name: name.value,
      },
    })

    device.value = response.data.device
  } catch (e) {
    console.log(e)
  }

  loading.value = false
}

function handleConfirm () {
  emit('confirm', device.value)
  dialog.value.close()
}

defineExpose({ open })
</script>
